/**
 * The Overview Building view's words and small rules (twin slice 1, plan W4
 * step 11), kept out of the lazily loaded view so the Overview can read
 * them without fetching the 3D chunk. Pure; no three.js.
 *
 * Every string here is copy for review (plan gate B).
 */
import type { TwinGeometry } from '../Twin/geometry';
import { drawnLifts } from '../Twin/lift-columns';

/** The building without its glass: the narrow tier's. Same object
 *  otherwise, so nothing rebuilds for it. */
export function withoutFacade(geometry: TwinGeometry): TwinGeometry {
  return geometry.facade_bands.length === 0 ? geometry : { ...geometry, facade_bands: [] };
}

/** What this view draws, by name, for the resolver's "Not drawn in this
 *  building view." */
export interface BuildingInventory {
  readonly lifts: ReadonlySet<string>;
  readonly doors: ReadonlySet<string>;
}

export function buildingInventory(geometry: TwinGeometry): BuildingInventory {
  return {
    lifts: new Set(drawnLifts(geometry).map((l) => l.name)),
    doors: new Set(geometry.levels.flatMap((l) => (l.doors ?? []).map((d) => d.name))),
  };
}

/** The camera buttons (W2 step 14). "Whole building" is the Overview's own
 *  word for it (`OVERVIEW_WORDS.wholeBuilding`). */
export const BUILDING_RESET_VIEW_TEXT = 'Reset view';
/** The camera buttons' group, for a screen reader. */
export const BUILDING_CAMERA_LABEL = 'Camera';

export const BUILDING_LOAD_FAILED_TEXT = "The building model couldn't be loaded.";
/** The Overview's reason when the Building view itself could not load
 *  (its code, not the model) or threw while drawing. */
export const BUILDING_VIEW_FAILED_TEXT = "The building view couldn't be loaded. Showing the map.";
export const BUILDING_NO_MODEL_TEXT = "There's no building model for this site yet.";
export const BUILDING_USE_MAP_TEXT = 'The map shows the same robots, lifts and doors.';
